import axios from "axios"
import { apiBaseUrl } from "./endpoints";
import { handleError } from "./apiUtils";

export const getApiResponse = async (url = '/') => {
    const apiUrl = apiBaseUrl + url;

    try {
        const response = await axios.get(apiUrl, {
            headers: { "Authorization": `Bearer ${localStorage.getItem('access_token')}` }
        });
        return response; 
    } catch (error) {
        // throw error; 
        handleError(error)
    }
}
